import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Dashboard from "../components/Dashboard";
import { fetchUserData, refreshAccessToken } from "../actions/user";
import { fetchSearchData } from "../actions/documentsearchbar";
import { fetchWhatNewData } from "../actions/dashboard";

const mapStateToProps = (state) => {
  return {
    data_new: state.dashboard.data_new,
    isFetching: state.dashboard.isFetching,

    // --- USER (login reducer)
    isFetchingSearch: state.documentsearchbar.isFetching,
    user: state.login.user,

    // --- SEARCH (documentsearchbar reducer)
    data: state.documentsearchbar.data,
    count: state.documentsearchbar.count,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchUserData,
      refreshAccessToken,
      fetchSearchData,
      fetchWhatNewData
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
